import { RouteModel } from '@/lib/models/route/types';
import { transformOption } from '@/lib/transformers/option';
import { calcMainOptionEmissions } from '@/lib/transformers/route/utils/calc-main-option-emissions';
import { calcArrivalReliability } from '@/lib/transformers/route/utils/calc-main-option-reliability';
import { getApiRouteFrequency } from '@/lib/transformers/route/utils/get-api-route-frequency';
import { getMainOptionSchedules } from '@/lib/transformers/route/utils/get-main-option-schedules';
import { sortApiRouteOptions } from '@/lib/transformers/route/utils/sort-api-route-options';
import { transformLinkSegment, transformTransferSegment } from '@/lib/transformers/segment';
import { RouteApiV4Interface } from '@/types/api-types';
import { getPrimaryMode } from '@/utils/format';
import { generateId } from '@/utils/helpers';

export const transformRoute = ({ route }: { route: RouteApiV4Interface }): RouteModel => {
  const { distanceKm, end, endTransfer, fromId, mainOptions, routeTypes, start, startTransfer, toId } = route;

  const sortedMainOptions = sortApiRouteOptions(mainOptions);
  const transformedMainOptions = sortedMainOptions.map((option) => transformOption({ option }));
  const totalDurationSeconds =
    (start?.durationSeconds || 0) + sortedMainOptions[0].totalDurationSeconds + (end?.durationSeconds || 0);

  return {
    id: generateId(),
    durationSeconds: totalDurationSeconds,
    toId,
    fromId,
    distanceKm,
    routeTypes,
    mainOptions: transformedMainOptions,
    startTransfer: startTransfer ? transformTransferSegment({ segment: startTransfer }) : undefined,
    start: start ? transformLinkSegment({ segment: start }) : undefined,
    endTransfer: endTransfer ? transformTransferSegment({ segment: endTransfer }) : undefined,
    end: end ? transformLinkSegment({ segment: end }) : undefined,
    primaryMode: getPrimaryMode(routeTypes),
    frequency: getApiRouteFrequency(sortedMainOptions),
    mainOptionEmissions: calcMainOptionEmissions(transformedMainOptions),
    arrivalOtp: calcArrivalReliability(transformedMainOptions),
    mainOptionSchedules: getMainOptionSchedules(mainOptions),
  };
};
